// extracted by mini-css-extract-plugin
export default {"backButton":"reset-password-form_backButton__glH+8","resetPasswordForm":"reset-password-form_resetPasswordForm__2Ygsh"};